import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "customselect" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z",
    fill: "white"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "selectlist-container__inner" }
const _hoisted_8 = ["data-value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wwr-select", { 'is-disable': _ctx.disabled }]),
    ref: "domSelect",
    id: 'wwrSelect_' + _ctx.id
  }, [
    _createElementVNode("label", { for: _ctx.name }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _withDirectives(_createElementVNode("input", {
      type: "hidden",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected.value) = $event))
    }, null, 512), [
      [_vModelText, _ctx.selected.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", {
        class: _normalizeClass(["selected", { 'is-active': _ctx.listActive }]),
        ref: "domSelected",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSelectClick && _ctx.handleSelectClick(...args)), ["prevent"]))
      }, [
        _createTextVNode(_toDisplayString(_ctx.selected.text) + " ", 1),
        _createElementVNode("i", {
          class: _normalizeClass(["svgicon svgicon--chevrondown", { 'is-active': _ctx.listActive }])
        }, _hoisted_5, 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["selectlist-container", { 'is-active': _ctx.listActive, 'has-transition': _ctx.hasTransition, 'is-bottomup': _ctx.isBottomUp } ]),
        id: 'wwrSelectContainer_' + _ctx.id,
        ref: "domSelectList",
        style: _normalizeStyle(_ctx.listStyle),
        onTransitionend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleTransitionEnd && _ctx.handleTransitionEnd(...args)))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", {
            class: _normalizeClass(["selectlist", { 'is-active': _ctx.listActive }]),
            ref: "domItems",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSelectListClick && _ctx.handleSelectListClick(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'optionItem' + _ctx.name + index,
                "data-value": option[_ctx.optionValue],
                class: _normalizeClass(["selectable", { 'is-selected': option[_ctx.optionValue] == _ctx.selected.value }])
              }, _toDisplayString(option[_ctx.optionText]), 11, _hoisted_8))
            }), 128))
          ], 2)
        ])
      ], 46, _hoisted_6)
    ])
  ], 10, _hoisted_1))
}